export var ApiKeyScope;
(function (ApiKeyScope) {
    ApiKeyScope["Metrics"] = "metrics";
    ApiKeyScope["DataExport"] = "dataExport";
    ApiKeyScope["Enrichment"] = "enrichment";
    ApiKeyScope["SessionReplay"] = "sessionReplay";
})(ApiKeyScope || (ApiKeyScope = {}));
//# sourceMappingURL=api-key.scope.js.map